import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { Option } from '../components/shared/ControlledFields/ControlledSelect';

const getLabel = (labelGetter: string | string[], item, joinBy = '') => {
  if (Array.isArray(labelGetter)) {
    return labelGetter.map((label) => item[label]).join(joinBy);
  }

  return item[labelGetter];
};

export const useGetOptions = (
  data: any[] | [],
  isError = false,
  valueGetter: string,
  labelGetter: string | string[],
  translationKey?: string,
  joinBy?: string
): Option[] | [] => {
  const { t } = useTranslation('common');

  return useMemo(() => {
    if (isError) {
      return [];
    }

    return (
      (data?.map((item) => ({
        value: item[valueGetter],
        label: translationKey
          ? t(`${translationKey}${getLabel(labelGetter, item, joinBy)}`)
          : getLabel(labelGetter, item, joinBy)
      })) as Option[]) ?? []
    );
  }, [data, isError, valueGetter, labelGetter, translationKey, t]);
};
